var $b9d08f9d50543ce2$exports = {};
$b9d08f9d50543ce2$exports = {
  "alert": `Br\u{12B}din\u{101}jums`,
  "dismiss": `Ner\u{101}d\u{12B}t`
};
export { $b9d08f9d50543ce2$exports as default };